import {
  Component,
  Input,
  OnInit,
  ViewChildren,
  QueryList,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { OffersOfApplication } from '../../../../type/result_type';
import { FocusManagementService } from '../../../../service/focus-management.service';

@Component({
  selector: 'app-proof',
  templateUrl: './proof.component.html',
  styleUrls: ['./proof.component.scss'],
})
export class ProofComponent implements OnInit, AfterViewInit {
  @Input() proofData!: OffersOfApplication;
  @Input() focusParentTab: () => void; // Function to focus parent tab
  @ViewChildren('focusableContent') focusableContents!: QueryList<ElementRef>;

  constructor(private focusManagementService: FocusManagementService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.focusManagementService.setupKeydownListeners(
      this.focusableContents,
      this.focusParentTab
    );
  }

  trackByTemplateId(index: number, item: { id?: string }) {
    return item?.id ?? `${index}`;
  }
}
